import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledEducatorsHome = styled('div')`
  background-color: ${COLOR.white};
  /* clip instead of hidden: clip does not create a scroll container, so the
     sticky header keeps sticking to the top of the page. */
  overflow-x: clip;

  .educators-content {
    padding: 40px 32px;
    box-sizing: border-box;
  }

  .educators-sections {
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 1120px;
    width: 100%;
    margin: 0 auto;
  }
`;
